import React from 'react';
import styled from 'styled-components';

import { SCROLL_SPY_DEBOUNCE_MS, SCROLL_SPY_OFFSET } from '../constants/scroll';
import { useScrollSpy } from '../hooks/useScrollSpy';
import { QUERIES } from '../constants/mediaQueries';
import GlobalStyles from '../styles/GlobalStyles';
import Nav from './Nav';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutStyles = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const HeaderStyles = styled.header`
  border-bottom: var(--border-default);
  background-color: var(--color-neutral-white);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  gap: 0;
  position: sticky;
  top: 0;
  height: var(--height-header);
  z-index: 100;

  ${QUERIES.maxTablet} {
    padding: var(--spacing-base);
  }
`;

const ContentStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  min-height: 85vh;
  overflow-x: auto;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Use the scroll spy hook to update URL with section anchors as user scrolls
  // We set offset to match the header height
  useScrollSpy({
    offset: SCROLL_SPY_OFFSET,
    debounceTime: SCROLL_SPY_DEBOUNCE_MS,
    updateURL: true,
    updateOnLoad: true,
  });

  return (
    <>
      <GlobalStyles />
      <HeaderStyles>
        <Nav />
      </HeaderStyles>
      <LayoutStyles>
        <ContentStyles>{children}</ContentStyles>
        <Footer />
      </LayoutStyles>
    </>
  );
};

export default Layout;
